 import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import API from '../api/axios';
import toast from 'react-hot-toast';

const inputStyle = {
  width: '100%', padding: '0.75rem 1rem',
  border: '1.5px solid var(--light-gray)',
  borderRadius: '10px', fontSize: '0.95rem',
  outline: 'none', background: 'var(--cream)',
  transition: 'var(--transition)'
};

function Field({ label, name, type = 'text', placeholder, required, value, onChange }) {
  return (
    <div style={{ marginBottom: '1.1rem' }}>
      <label style={{ display: 'block', marginBottom: '0.4rem', fontWeight: '500', fontSize: '0.9rem' }}>
        {label} {required && <span style={{ color: 'var(--danger)' }}>*</span>}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        required={required}
        style={inputStyle}
        onFocus={e => e.target.style.borderColor = 'var(--warm-brown)'}
        onBlur={e => e.target.style.borderColor = 'var(--light-gray)'}
      />
    </div>
  );
}

export default function Register() {
  const [form, setForm] = useState({
    full_name: '', email: '', password: '', phone: '', address: ''
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    setLoading(true);
    try {
      await API.post('/auth/register', form);
      toast.success('Account created! Please login.');
      navigate('/login');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Registration failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: 'calc(100vh - 70px)',
      display: 'flex', alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--cream)', padding: '2rem'
    }}>
      <div style={{
        background: 'var(--white)', borderRadius: '20px',
        padding: '3rem', width: '100%', maxWidth: '480px',
        boxShadow: 'var(--shadow-lg)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 style={{
            fontFamily: 'var(--font-display)',
            fontSize: '2rem', color: 'var(--charcoal)', marginBottom: '0.5rem'
          }}>Create Account</h1>
          <p style={{ color: 'var(--mid-gray)', fontSize: '0.95rem' }}>
            Join Kraftova and start shopping
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <Field label="Full Name" name="full_name" placeholder="John Doe" required value={form.full_name}
            onChange={e => setForm({ ...form, full_name: e.target.value })} />
          <Field label="Email Address" name="email" type="email" placeholder="you@example.com" required value={form.email}
            onChange={e => setForm({ ...form, email: e.target.value })} />
          <Field label="Password" name="password" type="password" placeholder="Min. 6 characters" required value={form.password}
            onChange={e => setForm({ ...form, password: e.target.value })} />
          <Field label="Phone Number" name="phone" placeholder="+91 9876543210" value={form.phone}
            onChange={e => setForm({ ...form, phone: e.target.value })} />

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.4rem', fontWeight: '500', fontSize: '0.9rem' }}>
              Delivery Address
            </label>
            <textarea
              placeholder="Enter your full delivery address"
              value={form.address}
              onChange={e => setForm({ ...form, address: e.target.value })}
              rows={3}
              style={{
                ...inputStyle, resize: 'vertical', lineHeight: '1.5'
              }}
              onFocus={e => e.target.style.borderColor = 'var(--warm-brown)'}
              onBlur={e => e.target.style.borderColor = 'var(--light-gray)'}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%', padding: '0.85rem',
              background: loading ? 'var(--mid-gray)' : 'var(--charcoal)',
              color: 'var(--white)', border: 'none',
              borderRadius: '10px', fontSize: '1rem',
              fontWeight: '600', transition: 'var(--transition)'
            }}
          >
            {loading ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.9rem', color: 'var(--mid-gray)' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: 'var(--warm-brown)', fontWeight: '600' }}>
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}